
import Vue from "vue";
import Component from "vue-class-component";
import { Action, State } from "vuex-class";
import { Watch } from "vue-property-decorator";

import VideoTutorial from "@/views/apps/help_center/VideoTutorial.vue";
import FaqList from "@/views/apps/help_center/FAQList.vue";

@Component({
  components: {
    VideoTutorial,
    FaqList,
  },
})
export default class HelpCenter extends Vue {
  /* VUEX */

  // ACTIONS
  @Action('actionSelectFAQCategory', { namespace: 'faq' })
  private actionSelectFAQCategory: any;
  @Action('actionSetCategory', { namespace: 'faq' })
  private actionSetCategory: any;
  @Action('actionSelectFAQByCategory', { namespace: 'faq' })
  private actionSelectFAQByCategory: any;

  // STATE
  @State('array_faq_category', { namespace: 'faq' })
  private array_faq_category: any;

  @Watch("tabActive")
  private onChangeTab(val: any) {
    if (val === 1) {
      this.getFirstFAQ();
    }
  }

  /* INITIALIZATION */
  private tabActive = 0;

  private created() {
    this.getFAQ();
  }

  /* METHODS */
  private getFAQ() {
    this.actionSelectFAQCategory();
  }

  private getFirstFAQ() {
    const category = this.array_faq_category[0];
    if (category) {
      this.actionSetCategory({ category });
      this.actionSelectFAQByCategory({
        id: category.id,
      });
    }
  }
}
